import { UserRewardType } from 'v2/constants';
import { SelectOption } from 'v2/types';
import { identifyArrayToSelect } from 'v2/utils';

export const options: SelectOption<UserRewardType>[] = identifyArrayToSelect([UserRewardType.CONTEST_TICKET]);
